import { render, staticRenderFns } from "./SorteoDetail.vue?vue&type=template&id=efbd4148&"
import script from "./SorteoDetail.vue?vue&type=script&lang=ts&"
export * from "./SorteoDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports